module.exports = __webpack_public_path__ + "images/category_lp/common/crown_97814f5ec9a040adf4c8a547db37ef13.png";